import React from 'react';
import { DRIItemType } from '../../../Common/models/DRIItem';

export const TypeBadge: React.FC<{ itemType: DRIItemType; theme: any }> = ({
    itemType,
    theme,
}) => {
    const colors: Record<DRIItemType, string> = {
        link: theme.palette.themePrimary,
        text: theme.palette.greenDark || '#107c10',
        script: theme.palette.orange || '#ca5010',
        kusto: theme.palette.purpleDark || '#5c2d91',
        sql: '#b4009e',
    };
    const labels: Record<DRIItemType, string> = {
        link: 'Link',
        text: 'Text',
        script: 'Script',
        kusto: 'Kusto',
        sql: 'SQL',
    };
    return (
        <span
            style={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#fff',
                backgroundColor:
                    colors[itemType] || theme.palette.neutralTertiary,
                borderRadius: '3px',
                padding: '2px 8px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
            }}
        >
            {labels[itemType] || itemType}
        </span>
    );
};
